import gsap from 'gsap';
import type { Ref } from 'vue';

/**
 * Drives the rotating conic-gradient stroke via `--btn-stroke-angle` (see `btn-stroke.scss`).
 */
export const useBtnStrokeAnimation = (refStroke: Ref<HTMLElement | null>) => {
    let tl: gsap.core.Timeline | undefined;

    const setStrokeActive = (active: boolean) => {
        tl?.kill();
        tl = undefined;

        if (!active || !refStroke.value) return;

        tl = gsap.timeline();
        tl.fromTo(
            refStroke.value,
            { '--btn-stroke-angle': '0deg' },
            { '--btn-stroke-angle': '360deg', duration: 1.8, ease: 'none', repeat: -1 },
            '<'
        );
    };

    return { setStrokeActive };
};
